import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqs: FAQItem[] = [
  {
    question: '介護保険外サービスとは何ですか？',
    answer: '介護保険外サービスとは、介護保険の対象外となるサポートを提供するサービスです。例えば、趣味の外出、旅行の付き添い、ペットの世話、庭の手入れなど、お客様の「やりたい」を実現するためのサポートを行います。'
  },
  {
    question: 'どのような資格を持ったスタッフが対応しますか？',
    answer: '介護福祉士、ヘルパー2級以上の国家資格を持ったスタッフが対応いたします。また、福祉タクシーの許可も取得しており、安全で質の高いサービスを提供いたします。'
  },
  {
    question: 'サービスエリアはどこまでですか？',
    answer: '鳥取市を中心にサービスを提供しております。その他のエリアについてもご相談に応じますので、お気軽にお問い合わせください。'
  },
  {
    question: '料金はどのように決まりますか？',
    answer: 'サポート内容、時間、距離などに応じて事前にお見積もりいたします。明確な料金体系で、安心してご利用いただけます。'
  },
  {
    question: 'キャンセルはできますか？',
    answer: '前日18:00までのキャンセルは無料です。それ以降のキャンセルについては、予約時間分をご請求させていただきます。急な体調不良等で開始3時間前までにご連絡いただき日程変更される場合は、キャンセル料は発生いたしません。'
  },
  {
    question: '家族への報告はしてもらえますか？',
    answer: 'はい、サービス終了後にご家族へ詳細な報告を行います。お客様の様子や活動内容を丁寧にお伝えし、安心していただけるよう努めております。'
  }
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-brand-dark mb-4">
            よくあるご質問
          </h2>
          <p className="text-gray-600 text-base">
            お客様からよくいただくご質問をまとめました
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-300"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left cursor-pointer whitespace-nowrap"
              >
                <h4 className="text-base font-bold text-brand-dark pr-4 flex-1">
                  <a id={`faq-${index + 1}`} className="hover:text-brand-yellow transition-colors duration-300">
                    {faq.question}
                  </a>
                </h4>
                <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center">
                  <i
                    className={`ri-arrow-down-s-line text-2xl text-brand-yellow transition-transform duration-300 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  ></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 pb-5">
                  <p className="text-gray-700 text-sm leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-600 text-sm mb-6">
            その他のご質問がございましたら、お気軽にお問い合わせください
          </p>
          <a
            href="tel:+817090045641"
            className="inline-flex items-center bg-brand-yellow text-brand-dark px-8 py-3 rounded-full font-bold hover:bg-yellow-500 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-line mr-2 text-xl"></i>
            お電話でのお問い合わせ
          </a>
        </div>
      </div>
    </section>
  );
}